import React from "react";
import "../../Styles/certified/tvsnext.css";

export default function Tvsnext() {
  return (
    <>
      <div className="tvsnext-certified-details-section">
        <div className="tvsnext-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="tvsnext-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="tvsnext-certified-details-left">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="tvsnext-certified-badge"
            />
            <div className="tvsnext-certified-company-names">
              <a href="https://tvsnext.com" target="_blank" rel="noopener noreferrer">
                <img src="/assets/tvsnext/tvsnext-logo.png" alt="TVS Next Logo" className="tvsnext-certified-company-logo" />
              </a>
              <h1 className="tvsnext-certified-full-name">
                TVS Next Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="tvsnext-certified-details-right">
            <img
              src="/assets/tvsnext/Picture_3.jpg"
              alt="TVS Next Office"
              className="tvsnext-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="tvsnext-certified-description">
          <h2>
            Why TVS Next Limited is a Outstanding Workplaces
          </h2>
          <p>
             TVS Next, backed by over 114 years of manufacturing legacy of TVS, is a leading technology and digital consulting firm that combines deep industry expertise with a modern, agile approach. 
             For decades, our DNA has been rooted in empowering our customers’ success, forging partnerships that last 40 to 50 years. 
             We specialize in solving complex business challenges through hyper-personalized and pragmatic solutions, leveraging technologies with a data-first mindset. 
             Our focus on governance, innovation, and process excellence ensures that we deliver measurable outcomes that drive growth and efficiency for our clients. 
             With a nimble and collaborative team, we partner closely with businesses to craft practical and impactful solutions, aligning with their goals and empowering their growth journey. 
             At TVS Next, we’re not just solving problems- we’re helping our customers succeed.
          </p>
        </div>
        {/* Info Cards Section */}
        <div className="tvsnext-certified-info-cards">
          <div className="tvsnext-certified-info-card">
            <div className="tvsnext-certified-info-title">COMPANY SIZE</div>
            <div className="tvsnext-certified-info-value">250+ Employees</div>
          </div>
          <div className="tvsnext-certified-info-card">
            <div className="tvsnext-certified-info-title">INDUSTRY</div>
            <div className="tvsnext-certified-info-value">Information Technology</div>
          </div>
          <div className="tvsnext-certified-info-card">
            <div className="tvsnext-certified-info-title">CONNECT</div>
            <div className="tvsnext-certified-info-icons">
              <span className="tvsnext-certified-icon-round">
                <a href="https://tvsnext.com" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="tvsnext-certified-icon-round">
                <a href="https://www.linkedin.com/company/tvsnext" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="tvsnext-certified-icon-round">
                <a href="https://www.facebook.com/tvsnxt" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
              <span className="tvsnext-certified-icon-round">
                <a href="https://www.instagram.com/tvsnext" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/instagram.png" alt="Instagram" />
                </a>
              </span>
              <span className="tvsnext-certified-icon-round">
                <a href="https://x.com/tvsnext" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/x.png" alt="X" />
                </a>
              </span>
            </div>
          </div>
          <div className="tvsnext-certified-info-card">
            <div className="tvsnext-certified-info-title">LOCATION (HQ)</div>
            <div className="tvsnext-certified-info-value">Chennai</div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="tvsnext-certified-recognition-section">
          <h2 className="tvsnext-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="tvsnext-certified-recognition-badge">
            <img
              src="/Dec2025Dec2026.png"
              alt="Outstanding Workplaces Certified"
              className="tvsnext-certified-recognition-image"
            />
          </div>
          <div className="tvsnext-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at TVS Next Section */}
        <div className="tvsnext-certified-life-section">
          <h2 className="tvsnext-certified-life-title">
            Life at TVS Next Limited
          </h2>
          <div className="tvsnext-certified-life-gallery">
            <div className="tvsnext-certified-life-col">
              <img src="/assets/tvsnext/Picture_1.jpg" alt="Office 1" className="tvsnext-certified-life-img" />
              <img src="/assets/tvsnext/Picture_5.jpg" alt="Meeting 1" className="tvsnext-certified-life-img" />
            </div>
            <div className="tvsnext-certified-life-col tvsnext-certified-life-center">
              <img src="/assets/tvsnext/Picture_4.jpg" alt="Main Office" className="tvsnext-certified-life-img tvsnext-certified-life-img-large" />
            </div>
            <div className="tvsnext-certified-life-col">
              <img src="/assets/tvsnext/Picture_6.jpg" alt="Office 2" className="tvsnext-certified-life-img" />
              <img src="/assets/tvsnext/Picture_2.jpg" alt="Meeting 2" className="tvsnext-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}